import * as React from 'react';
import { useCollection, COLLECTION_ACTION, useControlledState } from '../hooks';
import { DragContext, DropContext, DragsContext, DropsContext } from './context';
/**
 * The `DragAndDrop` component is required for the `droppable` functionality to work properly.
 *
 * It is used internally to synchronize the `drag` and `drop` functionalities.
 * Accepts properties of type [DragAndDropProps]({% slug api_common_draganddropprops %}).
 */
export var DragAndDrop = function (props) {
    var _a = useControlledState(null, undefined), drag = _a[0], setDrag = _a[1];
    var _b = useControlledState(null, undefined), drop = _b[0], setDrop = _b[1];
    var _c = useCollection([]), drags = _c[0], dispatchDrags = _c[1];
    var _d = useCollection([]), drops = _d[0], dispatchDrops = _d[1];
    var registerDrag = function (item) {
        dispatchDrags({
            type: COLLECTION_ACTION.add,
            item: item
        });
    };
    var deregisterDrag = function (item) {
        dispatchDrags({
            type: COLLECTION_ACTION.remove,
            item: item
        });
    };
    var registerDrop = function (item) {
        dispatchDrops({
            type: COLLECTION_ACTION.add,
            item: item
        });
    };
    var deregisterDrop = function (item) {
        dispatchDrops({
            type: COLLECTION_ACTION.remove,
            item: item
        });
    };
    return (React.createElement(DragContext.Provider, { value: [drag, setDrag] },
        React.createElement(DropContext.Provider, { value: [drop, setDrop] },
            React.createElement(DragsContext.Provider, { value: [drags, registerDrag, deregisterDrag] },
                React.createElement(DropsContext.Provider, { value: [drops, registerDrop, deregisterDrop] }, props.children)))));
};
DragAndDrop.displayName = 'KendoReactDragAndDrop';
